import React, { useState } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { Button } from "antd";
import Select from "react-select";
import { Delete, PlusCircle, Trash2 } from "react-feather";
import { format } from "date-fns";
import Input from "Components/UI/Input";
import dayjs from "dayjs";
import ImageUploader from "Components/UI/ImageUploder";
import ImageCropper from "Components/UI/Image/ImageCropper";
const activestatus = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];


const workingStatusOptions = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

const DependantDetails = () => {
  const {
    control,
    register,
    setValue,
    getValues,
    watch,
    formState: { errors },
    trigger,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "dependantDetail",
  });

  const dependantDetails = watch("dependantDetail") || [];

  const addDependantDetailRow = () => {
    const newExperience = {
      companyCode: watch("companyCode"),
      code: 0,
      employeeCode: watch("employeeCode"),
      dependantName: "",
      icNumber: "",
      appliedOn: "",
      issuedOn: "",
      expiryDate: "",
      remarks: "",
      fin: "",
      relationship: "",
      working: "",
      companySponsored: true,
      frontImage: "",
      backImage: "",
      isActive: true,
      createUser: watch("createUser"),
      modifyUser: watch("modifyUser"),
      createDate: watch("createDate"),
      modifyDate: watch("modifyDate"),
    };

    setValue("dependantDetail", [...dependantDetails, newExperience]);
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 16,
        }}
      >
        <h4></h4>
        <button
          className="btn btn-secondary btn-sm "
         type="button"
          onClick={addDependantDetailRow}
        >
          <PlusCircle className="me-2" />
          Add Row
        </button>
      </div>
      <div className="table-responsive" style={{ minHeight: "250px" }}>
        <table className="table custom-table table-nowrap mb-0">
          <thead>
            <tr>
              <th>-</th>
              <th>Dependant Name</th>
              <th>IC Number</th>
              <th>Applied On</th>
              <th>Issue On</th>
              <th>Expiry Date</th>
              <th>Fin</th>
              <th>Relationship</th>
              <th>Company Sponsored</th>
              <th>Status</th>
              <th>Front Image</th>
              <th>Back Image</th>
              
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {dependantDetails.map((data, index) => {
              return (
                <tr key={index}>
                  <td>
                    <Button type="danger" onClick={() => remove(index)}>
                      <Trash2 />
                    </Button>
                  </td>
                  <td>
                    <Input
                      name={`dependantDetail[${index}].dependantName`}
                      type="text"
                      placeholder="Dependant Name"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.dependantName
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`dependantDetail[${index}].icNumber`}
                      type="text"
                      placeholder="IC Number"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.icNumber
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`dependantDetail[${index}].appliedOn`}
                      type="date"
                      placeholder="Applied On"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.appliedOn
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`dependantDetail[${index}].appliedOn`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>
                  <td>
                    <Input
                      name={`dependantDetail[${index}].issuedOn`}
                      type="date"
                      placeholder="Issued On"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.issuedOn
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`dependantDetail[${index}].issuedOn`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`dependantDetail[${index}].expiryDate`}
                      type="date"
                      placeholder="Expiry Date"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.expiryDate
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      defaultValue={
                        dayjs(
                          watch(`dependantDetail[${index}].expiryDate`),
                          "YYYY-MM-DD"
                        ) || ""
                      }
                      dateFormat="YYYY-MM-DD"
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`dependantDetail[${index}].fin`}
                      type="text"
                      placeholder="fin"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.fin
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`dependantDetail[${index}].relationship`}
                      type="text"
                      placeholder="Sposorship"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.relationship
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

                  <td>
                    <Input
                      name={`dependantDetail[${index}].working`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.dependantDetail?.[index]?.working
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={workingStatusOptions}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "dependantDetail[${index}].working",
                          selectedOption
                        );
                        trigger("dependantDetail[${index}].working");
                      }}
                      defaultValue={watch("dependantDetail[${index}].working")}
                    />
                  </td>
                  
                  <td>
                    <Input
                      name={`dependantDetail[${index}].companySponsored`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.dependantDetail?.[index]?.companySponsored
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={activestatus}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "dependantDetail[${index}].companySponsored",
                          selectedOption
                        );
                        trigger("dependantDetail[${index}].companySponsored");
                      }}
                      defaultValue={watch("dependantDetail[${index}].companySponsored")}
                    />
                  </td>


                  <td>
                    <ImageCropper
                      base64Value={watch(
                        `dependantDetail[${index}].frontImage`
                      )}
                      setBase64Value={(value) =>
                        setValue(`dependantDetail[${index}].frontImage`, value)
                      }
                    />
                  </td>

                  <td>
                    <ImageCropper
                      base64Value={watch(`dependantDetail[${index}].backImage`)}
                      setBase64Value={(value) =>
                        setValue(`dependantDetail[${index}].backImage`, value)
                      }
                    />
                  </td>

                  
                  <td>
                    <Input
                      name={`dependantDetail[${index}].remarks`}
                      type="text"
                      placeholder="Sposorship"
                      className={`form-control ${
                        errors?.dependantDetail?.[index]?.remarks
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName=""
                      required={false}
                      requiredMessage=""
                      style={{ width: "200px" }}
                    />
                  </td>

{/* 
                  <td>
                    <Input
                      name={`dependantDetail[${index}].isActive`}
                      type="commonSelect"
                      placeholder=""
                      className={`form-control ${
                        errors.dependantDetail?.[index]?.isActive
                          ? "is-invalid"
                          : ""
                      }`}
                      label=""
                      labelClassName="form-label"
                      optionData={activestatus}
                      required={true}
                      requiredMessage="Active Status is required"
                      onChange={(selectedOption) => {
                        setValue(
                          "dependantDetail[${index}].isActive",
                          selectedOption
                        );
                        trigger("dependantDetail[${index}].isActive");
                      }}
                      defaultValue={watch("dependantDetail[${index}].isActive")}
                    />
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DependantDetails;
